import { render, staticRenderFns } from "./group-open-loan-table.vue?vue&type=template&id=d95354ea"
import script from "./group-open-loan-table.vue?vue&type=script&lang=js"
export * from "./group-open-loan-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../AppData/Roaming/nvm/v12.14.1/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports